export interface CarInvestor {
    id: string;
    name: string;
    amount: number;
    percentage: number;
}

export default class Car {
    id: string;
    year: number;
    make: string;
    model: string;
    price: number;
    purchase_cost: number;
    mileage: string;
    archive: boolean;
    featured: boolean;
    images: string[];
    description: string;
    color: string;
    investors: CarInvestor[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(data: any = {}) {
        this.id = data.id || `temp-${Math.random().toString(36).substr(2, 9)}`;
        this.year = data.year || new Date().getFullYear();
        this.make = data.make || '';
        this.model = data.model || '';
        this.price = data.price || 0;
        this.purchase_cost = data.purchase_cost || 0;
        this.mileage = data.mileage || '';
        this.archive = data.archive || false;
        this.featured = data.featured || false;
        this.images = Array.isArray(data.images) ? data.images : (data.image ? [data.image] : []);
        this.description = data.description || '';
        this.color = data.color || '';
        this.investors = data.investors || [];
    }
}